/* tslint:disable */
/* eslint-disable */
/**
 * Risks API
 * API for managing risks.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SimpleGuaranteeDto
 */
export interface SimpleGuaranteeDto {
    /**
     * Unique identifier of the guarantee
     * @type {string}
     * @memberof SimpleGuaranteeDto
     */
    id: string;
    /**
     * Guarantee designation/label
     * @type {string}
     * @memberof SimpleGuaranteeDto
     */
    label: string;
    /**
     * Price excluding taxes
     * @type {number}
     * @memberof SimpleGuaranteeDto
     */
    priceHT: number;
    /**
     * Price including taxes
     * @type {number}
     * @memberof SimpleGuaranteeDto
     */
    priceTTC: number;
}

/**
 * Check if a given object implements the SimpleGuaranteeDto interface.
 */
export function instanceOfSimpleGuaranteeDto(value: object): value is SimpleGuaranteeDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('priceHT' in value) || value['priceHT'] === undefined) return false;
    if (!('priceTTC' in value) || value['priceTTC'] === undefined) return false;
    return true;
}

export function SimpleGuaranteeDtoFromJSON(json: any): SimpleGuaranteeDto {
    return SimpleGuaranteeDtoFromJSONTyped(json, false);
}

export function SimpleGuaranteeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SimpleGuaranteeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'label': json['label'],
        'priceHT': json['priceHT'],
        'priceTTC': json['priceTTC'],
    };
}

export function SimpleGuaranteeDtoToJSON(json: any): SimpleGuaranteeDto {
    return SimpleGuaranteeDtoToJSONTyped(json, false);
}

export function SimpleGuaranteeDtoToJSONTyped(value?: SimpleGuaranteeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'label': value['label'],
        'priceHT': value['priceHT'],
        'priceTTC': value['priceTTC'],
    };
}

